module.exports = __webpack_public_path__ + "static/media/RA-AC0009S.acca7413.png";